import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7b1092b1")

_pushScopeId("data-v-7b1092b1")
const _hoisted_1 = { class: "header-wrapper" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_navbar = _resolveComponent("navbar")
  const _component_el_col = _resolveComponent("el-col")
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_el_row = _resolveComponent("el-row")
  const _component_pageHeader = _resolveComponent("pageHeader")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { class: "header-nav" }, {
      default: _withId(() => [
        _createVNode(_component_el_col, { span: 20 }, {
          default: _withId(() => [
            _createVNode(_component_navbar)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 4,
          class: "nav-right"
        }, {
          default: _withId(() => [
            _createVNode(_component_Avatar)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_pageHeader, {
      class: "page-content",
      content: _ctx.route.meta.title
    }, null, 8, ["content"])
  ]))
})